import { Toasts } from '@fourthwall/components'
import { HasuraApiClient } from '@fourthwall/services/dist/HasuraApiClient'
import { downloadCsvFile } from '@fourthwall/utils/dist/downloadCsvFile'
import { useCurrentShopQuery } from '@modules/Dashboard/hooks/useCurrentShopQuery'
import { useMutation } from '@tanstack/react-query'

export const useMailingListReport = () => {
  const { currentShopQuery } = useCurrentShopQuery()
  const { mutate } = useMutation({
    mutationFn: async (shopId: string) => {
      const { data } = await HasuraApiClient.getMailingListReport(shopId)

      return data
    },
  })

  const handleSuccess = (data: object[]) => {
    if (!data.length) {
      return Toasts.notify('There is no data to export.', { type: 'info' })
    }

    downloadCsvFile(data, `${currentShopQuery.data?.name}-mailing-list-report`)
  }

  const download = () => {
    if (!currentShopQuery.data) return

    mutate(currentShopQuery.data.id, {
      onSuccess: ({ admin_mailing_lists_report: data }) => {
        handleSuccess(data)
      },
    })
  }

  return {
    mailingListReport: {
      download,
    },
  }
}
